"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ellipses = Ellipses;
exports["default"] = void 0;
var _PendingSimple = _interopRequireDefault(require("@tvg/fuse-icons/lib/PendingSimple"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _iconElement = require("../../fuse-icon-element/src/icon-element");
var _grid = require("../../fuse-responsive-grid/src/grid");
var _styledPagination = require("./styled-pagination");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
/* eslint-disable react/jsx-indent */

var IconWrapper = (0, _styledComponents["default"])(_styledPagination.ListStyled).attrs({
  className: 'fuse-pagination__ellipses',
  'data-testid': 'fuse-pagination__ellipses'
}).withConfig({
  displayName: "ellipses__IconWrapper",
  componentId: "sc-y3u1ot-0"
})(["display:flex;width:var(--spacing-global-space7);margin-right:var(--spacing-global-space3);align-items:center;justify-content:center;@media screen and (max-width:", "){width:var(--spacing-global-space5);margin-right:var(--spacing-global-space4);}"], _grid.gridConfig.s.maxWidth);
function Ellipses() {
  return /*#__PURE__*/_react["default"].createElement(IconWrapper, {
    "aria-hidden": true
  }, /*#__PURE__*/_react["default"].createElement(_iconElement.Icon, {
    icon: /*#__PURE__*/_react["default"].createElement(_PendingSimple["default"], null),
    color: "var(--color-greys-grey7)",
    responsiveSize: "medium"
  }));
}
Ellipses.displayName = 'Ellipses';
var _default = exports["default"] = Ellipses;